import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AxiosInstance } from 'axios';
import { type ApiError, type ApiResponse, useAxiosInstance } from 'shared/hooks/utils';
import { addActionNameToMutationResult } from 'shared/hooks/utils/add-action-name-to-mutation-result';

export type DeleteProductVariables = {
  id: string;
};

export async function deleteProductFn(
  axiosInstance: Promise<AxiosInstance>,
  variables: DeleteProductVariables,
): Promise<ApiResponse> {
  const { id } = variables;
  const instance = await axiosInstance;

  return instance.delete(`products/${id}`);
}

export function useDeleteProduct() {
  const client = useQueryClient();
  const axiosInstance = useAxiosInstance();

  const mutation = useMutation<ApiResponse, ApiError, DeleteProductVariables>({
    mutationFn: variables => deleteProductFn(axiosInstance, variables),
    onSuccess: () => {
      client.invalidateQueries({ queryKey: ['products'] });
    },
  });

  return addActionNameToMutationResult<
    ApiResponse,
    ApiError,
    DeleteProductVariables,
    'deleteProduct'
  >('deleteProduct', mutation);
}
